// src/components/io/StateIO.js
import React, { useRef } from 'react';
import { useTable } from '../../context/TableContext.js';

const toSnapshot = (s) => ({
  version: 1,
  meta: { savedAt: new Date().toISOString() },
  rows: s.rows,
  columns: s.columns,
  tableSize: s.tableSize,
  orientation: s.orientation,
  headerRows: s.headerRows,
  footerRows: s.footerRows,
  labels: s.labels || [],
  addedTable: !!s.addedTable,
  cells: s.cells,
});

export default function StateIO() {
  const { state, actions } = useTable();
  const fileInputRef = useRef(null);

  const handleSaveJson = () => {
    const snapshot = toSnapshot(state);
    const json = JSON.stringify(snapshot, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `table-state-${new Date().toISOString().slice(0,19).replace(/[:T]/g,'-')}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const openFilePicker = () => fileInputRef.current?.click();

  const onPickFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const snap = JSON.parse(String(reader.result || ''));
        actions.loadSnapshot(snap);
      } catch (err) {
        console.error('Invalid JSON:', err);
        alert('Failed to load JSON. Please select a valid snapshot file.');
      } finally {
        e.target.value = ''; // reset so same file can be picked again
      }
    };
    reader.readAsText(file);
  };

  return (
    <div className="mt-4 border-t pt-4">
      
      <div className="flex gap-2 justify-center align-center">
        <h3 className="text-lg font-medium text-gray-900 mb-3">State Import/Export</h3>
        <button
          onClick={handleSaveJson}
          className="px-3 py-2 bg-indigo-600 text-white rounded-md text-sm hover:bg-indigo-700"
          data-testid="button-save-json"
        >
          <i className="fas fa-save mr-2" />
          Save .json
        </button>
        <button
          onClick={openFilePicker}
          className="px-3 py-2 bg-white border border-gray-300 rounded-md text-sm hover:bg-gray-50"
          data-testid="button-load-json"
        >
          <i className="fas fa-file-upload mr-2" />
          Load .json
        </button>
        <input
          ref={fileInputRef}
          type="file"
          accept="application/json"
          hidden
          onChange={onPickFile}
        />
      </div>
      <p className="text-xs text-gray-500 mt-2">
        The JSON includes rows, columns, headers/footers, labels, cells (content/styles/merge info), and flags.
      </p>
    </div>
  );
}
